import * as React from 'react';

const Diners = (props: React.ComponentProps<'svg'>) => (
  <svg
    viewBox="0 0 58 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    focusable="false"
    {...props}
  >
    <rect x="0.5" y="0.5" width="57" height="39" rx="5.5" fill="white" />
    <rect x="0.5" y="0.5" width="57" height="39" rx="5.5" stroke="#E5E7EB" />
    <path
      d="M30.7243 8.00137C37.4783 7.89633 42.9664 13.3602 43.0719 20.0844V20.1889C42.8608 26.808 37.4783 32.1664 30.7243 32.1664H26.3971C19.8543 32.0612 14.5778 26.7029 14.5778 20.1889C14.3668 13.6749 19.4324 8.2115 25.8698 8.00137H30.7243ZM26.7135 10.1029C21.2261 10.1032 16.6881 14.6211 16.6881 20.0844C16.6884 25.5475 21.2262 30.0646 26.7135 30.0648C32.201 30.0648 36.7396 25.5476 36.7399 20.0844C36.7399 14.6209 32.2012 10.1029 26.7135 10.1029ZM25.1315 26.808C21.4379 25.8624 19.2208 22.08 20.1705 18.4027C20.8037 15.9862 22.7043 14.0956 25.1315 13.4652V26.808ZM28.2965 13.4652C31.9901 14.4108 34.3127 18.0878 33.3629 21.765C32.7297 24.2866 30.8293 26.1776 28.2965 26.808V13.4652Z"
      fill="#0079BE"
    />
  </svg>
);

export default Diners;
